import { isValidFederalWasteCodeForImport } from "./federalWasteCodes";
import { normalizeStateWasteCode } from "./stateWasteCodeNormalization";
import { isValidStateWasteCodeInAnyState, isValidTxWasteCodeFormat } from "./stateWasteCodes";

/** Checks code recognition/format; shipment-specific classification remains a separate review. */
export function invalidManifestCorrectionWasteCodes(
  field: string,
  codes: readonly string[]
): string[] {
  return codes.filter((raw) => {
    const code = raw.trim().toUpperCase();
    if (field === "federalWasteCodes") return !isValidFederalWasteCodeForImport(code);
    if (field !== "stateWasteCodes") return false;
    const normalized = normalizeStateWasteCode(code) ?? code;
    return !isValidStateWasteCodeInAnyState(normalized) && !isValidTxWasteCodeFormat(normalized);
  });
}
